import React from "react";
import {IMAGES_URL, LOCALE} from "modules/constants";
import styled from "styled-components";
import {get} from "lodash";

const SQUAD_ITEM_HEIGHT = 45;

const Wrapper = styled.div`
	background: linear-gradient(354.75deg, #e5e5e5 -3.11%, #f5f5f5 96.5%);
	border-bottom: 1px solid #cccccc;
	height: ${SQUAD_ITEM_HEIGHT}px;
	display: flex;
	align-items: center;
	padding: 8px 10px;
	font-size: 14px;
`;

const Number = styled.div`
	color: #00000033;
	margin-right: 8px;
	font-weight: 900;
	width: 25px;
`;

const SquadLogoFigure = styled.div`
	margin-right: 18px;
	width: 30px;
`;

export const SquadLogo = styled.img`
	width: 100%;
	max-width: 100%;
`;

const Name = styled.div`
	font-weight: 600;
	color: ${({theme}) => theme.color.secondary};
`;

interface ISquadItemProps {
	index: number;
	id: number;
	fullName: Record<string, string>;
	shortName: string;
}

export const SquadItem: React.FC<ISquadItemProps> = ({index, fullName, shortName}) => {
	const name = get(fullName, LOCALE, "");

	return (
		<Wrapper>
			<Number>#{index + 1}</Number>
			<SquadLogoFigure>
				<SquadLogo src={`${IMAGES_URL}image/squads/${shortName}.svg`} />
			</SquadLogoFigure>
			<Name>{name}</Name>
		</Wrapper>
	);
};
